import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
/*import styles from '../../../../styles/users/user.scss'; */
import { ButtonType, Button } from '@checkmarx/cx-ui';
import styles from '../style.scss';
import ToastrLevelsEnum from '../../../../services/enums/toastrLevelsEnum';
import ToastrService from '../../../../services/ui/toastrService';

@inject('translationsStore', 'twoFAStore','adminConfigurationStore') @observer

export default class AuthOptions extends Component {

    mfaStore = this.props.twoFAStore;

    componentDidMount() {
        this.props.adminConfigurationStore.getTwoFactorSettings();
        this.props.twoFAStore.isClientRemembered().then((response) => {
            this.props.twoFAStore.isForgetMeEnabled = response;
        });
        this.props.twoFAStore.getTwoFactorStatus().then((response) => {
            this.props.twoFAStore.is2FAEnabled = response;
        });
    }

    forgetBrowser = () => {
        this.mfaStore.forgetBrowser().then((response) => {
            this.props.twoFAStore.isForgetMeEnabled = false;
            var level = ToastrLevelsEnum.SUCCESS;
            var message = this.props.translationsStore.translate('TWOFACTOR_FORGET_SUCCESS');
            ToastrService.triggerToastr({ level, message });
        });
    };

    render() {
        
        const { currentStep, is2FAEnabled, twoFactorSteps } = this.props.twoFAStore;
        const { twoFAEnforced } = this.props.adminConfigurationStore;
        return (
            <div>
                <div className='twoFAContent' style={{ display: is2FAEnabled ? 'none' : 'block' }}>{this.props.translationsStore.translate('TWOFA_INACTIVE_MESSAGE')}<br /><br />
                    {this.props.translationsStore.translate('TWOFA_SETUP_MESSAGE')}
                </div>
                <div className='twoFAHeader' style={{ display: is2FAEnabled ? 'block' : 'none' }}>
                    <div className='tab-dialog'>
                        {this.props.translationsStore.translate('TWOFACTOR_HEADER')}
                    </div>
                    <div className='twoFAButtonDiv' style={{ display: 'flex' }}>
                        <div style={{ 'display': this.props.twoFAStore.isForgetMeEnabled ? 'block' : 'none' }}>
                        <Button
                            type="submit"
                            id="btnForgetMe"
                            dataCy="forget-this-browser"
                            text={this.props.translationsStore.translate('FORGETBROWSER')}
                            onClick={this.forgetBrowser} />
                        </ div>
                        <Button
                            disabled={twoFAEnforced}
                            type="submit"
                            id="btnDisableTwoFactor"
                            dataCy="disable-two-factor"
                            text={this.props.translationsStore.translate('DISABLETWOFACTOR')}
                            onClick={() => this.props.twoFAStore.changeStep(twoFactorSteps.disable2fa)} />
                           <Button
                            type="submit"
                            id="btnResetRecoveryCodes"
                            dataCy="reset-recovery-codes"
                            text={this.props.translationsStore.translate('RESETRECOVERYCODES')}
                            onClick={() => this.props.twoFAStore.changeStep(twoFactorSteps.resetcodes)} />
                    </div>
                    <div className='tab-dialog' style={{ paddingTop: '40px' }}>
                        {this.props.translationsStore.translate('AUTHENTICATOR_APP')}
                    </div>
                </div>
                <div className='twoFAButtonDiv'>
                    <div style={{ paddingBottom: '40px' }}>
                        <Button
                            type="submit"
                            id="btnSetUpAuthApp"
                            dataCy="set-auth-app"
                            text={this.props.translationsStore.translate('SETUPAUTHAPP')}
                            onClick={() => this.props.twoFAStore.changeStep(twoFactorSteps.setupauthapp)}
                        />
                        <Button
                            type="submit"
                            id="btnResetAuthApp"
                            dataCy="reset-auth-app"
                            text={this.props.translationsStore.translate('RESETUPAUTHAPP')}
                            style={{ display: is2FAEnabled ? 'inline':'none' }}
                            onClick={() => this.props.twoFAStore.changeStep(twoFactorSteps.resetauthkey)}
                        />
                    </div>
                </div>
            </div>
        )
    }
}
